<template>
    <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible">

        <el-form :model="obj" ref="addEditForm" status-icon :rules="rules">
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item prop="name">
                        <el-tooltip class="item" effect="dark" content="Interne naam voor de sponsor" placement="top">
                            <el-input placeholder="Naam" v-model="obj.name" prefix-icon="el-icon-wallet"></el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item prop="websiteURL">
                        <el-tooltip class="item" effect="dark" content="Webpagina van de sponsor" placement="top">
                            <el-input placeholder="URL" v-model="obj.websiteURL" prefix-icon="el-icon-link"></el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <file-upload :file-list="fileList"
                             help-text="Klik om een logo te uploaden"
                             tip="jpg/png bestanden kleiner dan 2MB"
                             :limit="1"
                             ref="fileUpload"></file-upload>
            </el-row>
        </el-form>

        <!-- Footer -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Annuleer</el-button>
            <el-button type="primary" @click="submitForm('addEditForm')" :loading="loading">Opslaan</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import FileUpload from "../../forms/FileUpload";
    export default {
        name: "SponsorDialog",
        components: {FileUpload},
        props: [
            'FileUpload'
        ],
        data() {
            return {
                dialogTitle: "",
                itemName: "Sponsor",
                dialogVisible: false,
                adding: false,
                obj: this.getEmptyObject(),
                loading: false,
                fileList: [],

                // Rules
                rules: {
                    name: [
                        {required: true, message: 'Voer een naam in.', trigger: 'blur'}
                    ],
                    websiteURL: [
                        {required: true, message: 'Voer een URL in.', trigger: 'blur'}
                    ],
                }
            }
        },
        methods: {
            edit(obj) {
                this.dialogTitle = `${this.itemName} wijzigen`
                this.dialogVisible = true
                this.adding = false
                this.obj = JSON.parse(JSON.stringify(obj));
                this.fileList = [this.obj.logo]
                this.reset()
            },
            add() {
                this.dialogTitle = `${this.itemName} toevoegen`
                this.dialogVisible = true
                this.adding = true
                this.obj = this.getEmptyObject()
                this.fileList = []
                this.reset()
            },
            reset() {
                if(this.$refs['addEditForm']) {
                    this.$refs['addEditForm'].resetFields()
                }
            },
            getEmptyObject() {
                return {
                    // Form data
                    name: "",
                    websiteURL: "",
                    logo: null
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // Process attachments
                        const att = this.$refs['fileUpload'].getAttachmentIds()

                        if(att.length > 0) {
                            this.loading = true;
                            this.obj.attachmentId = att[0];
                            console.log(this.obj)
                            if (this.adding) {
                                this.$parent.objAdded(this.obj);
                            } else {
                                this.$parent.objEdited(this.obj);
                            }
                        } else {
                            this.$message({
                                showClose: true,
                                message: 'Gelieve een logo te uploaden.',
                                type: 'error'
                            });
                            return false;
                        }

                    } else {
                        this.$message({
                            showClose: true,
                            message: 'Gelieve alle informatie correct in te vullen.',
                            type: 'error'
                        });
                        return false;
                    }
                });
            },
            close() {
                this.loading = false;
                this.dialogVisible = false;
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/dashboard/sponsors/dialogs/SponsorDialog.vue